/* Version: 3.5.155 */
'use client';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';
import { noop } from '../utils/functions.js';

// Maintains a flag to determine whether a value should be considered derived
// A value can move from local to derived, but never from derived to local. Ideally this should never happen,
// but it's easy to see a scenario where someone passes a value from an uninitialized useState call.
// Also accepts an optional cleanup function, to be called when a value moves from local to derived (this should
// only ever happen once, at most).
function useDerivedFlag(derivedValue) {
  var cleanup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
  var _useState = useState(derivedValue !== undefined),
    _useState2 = _slicedToArray(_useState, 2),
    isDerived = _useState2[0],
    setIsDerived = _useState2[1];
  useEffect(function () {
    // if derivedValue isn't undefined, it means we need to move to derived state
    // this should only ever happen once per value at most, for the lifetime of a component
    if (!isDerived && derivedValue !== undefined) {
      setIsDerived(true);
      cleanup();
    }
  }, [derivedValue, isDerived, cleanup]);
  return isDerived;
}

export { useDerivedFlag as default };
